const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 50,
    y1: 40,
    x2: 50,
    y2: 100,
    id: "Gradient1",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccc",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    },
    offset: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 60,
    id: "Gradient2",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#301D00",
      stopOpacity: 1
    },
    offset: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#FFAB00",
      stopOpacity: 1
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eee",
      stroke: "#999",
      strokeWidth: 1
    },
    d: "M 2,23 77,6 94,75 18,94 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#Gradient1)",
      stroke: "#444",
      strokeWidth: 1
    },
    d: "M 8,27 73,12 88,71 22,88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eee",
      stroke: "#999",
      strokeWidth: 1
    },
    d: "m 19,12 77,0 0,74 -77,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#Gradient2)",
      stroke: "#444"
    },
    d: "m 25,18 65,0 0,62 -65,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#Gradient1)",
      stroke: "#666"
    },
    d: "m 25,48 0,32 65,0 0,-45 C 90,35 84,51 77,54 68,58 64,52 61,46 57,54 56,58 50,60 44,62 38,45 36,38 32,43 29,47 25,48 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3D3D",
      fillOpacity: 0.6,
      stroke: "#730000",
      strokeWidth: 2
    },
    d: "M 53,44 44,53 61,71 44,88 53,97 71,80 88,97 96,88 80,71 97,52 89,44 71,61 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissing);
export default __webpack_public_path__ + "static/media/missing.a455b0df450f937048ab3b7f52742d8c.svg";
export { ForwardRef as ReactComponent };